<template>
    <a href="#" :class="isLikingClasses" @click.prevent="toggleLike">
        <span class="icon-thumbs-up"></span>{{ likeText }}
    </a>
</template>

<script>
export default {
    mounted() {
        this.isLikingProp = this.isLiking;

        this.likesProp = this.likes;
    },

    props: {
        url: String,
        likes: Number,
        isLiking: Boolean
    },

    data: function () {
        return {
            disableButton: false,
            isLikingProp: false,
            likesProp: 0
        };
    },

    computed: {
        likeText: function () {
            if (this.isLikingProp) {
                return 'Gillar';
            } else {
                return 'Gilla';
            }
        },

        isLikingClasses: function () {
            return {
                'like-post-button': true,
                btn: true,
                off: this.isLikingProp,
                on: !this.isLikingProp
            };
        }
    },

    methods: {
        toggleLike: function () {
            if (this.disableButton) return;

            this.disableButton = true; // Disable button

            this.isLikingProp = !this.isLikingProp;

            this.increaseOrDecreaseLikes();

            var callback = function (err, res) {
                if (err) {
                    this.isLikingProp = !this.isLikingProp;
                    this.increaseOrDecreaseLikes();
                    console.error(err);
                }

                this.disableButton = false; // Enable button
            };

            request.post(this.url).end(callback.bind(this));
        },

        increaseOrDecreaseLikes: function () {
            if (this.isLikingProp) {
                this.likesProp++;
            } else {
                this.likesProp--;
            }
        }
    }
};
</script>
